module.exports = __webpack_public_path__ + "assets/img/Facebook.f832dcdf.svg";